"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParamsEffect = exports.getQueryParams = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _params = require("hub-http/helpers/params");

var _customHooks = require("./customHooks");

var parseQueryParams = function parseQueryParams(queryString) {
  var queryParams = (0, _params.parse)(queryString.replace('?', ''));
  var ParamsThatShouldBeArray = [// Hard-coded list of params whose values we must return as an array
  'addons', 'services', 'selectedAddOns', 'selectedServices'];
  Object.keys(queryParams).forEach(function (key) {
    var value = queryParams[key];
    var adaptedValue;

    try {
      if (Array.isArray(value)) {
        adaptedValue = value.map(JSON.parse);
      } else {
        adaptedValue = JSON.parse(value);

        if (ParamsThatShouldBeArray.includes(key)) {
          adaptedValue = [adaptedValue];
        }
      }
    } catch (e) {
      adaptedValue = value;
    }

    queryParams[key] = adaptedValue;
  });
  return queryParams;
};

var stringifyQueryParams = function stringifyQueryParams(queryParams) {
  // Delete falsey params to maintain clean query string
  Object.keys(queryParams).forEach(function (key) {
    return !queryParams[key] && delete queryParams[key];
  });
  return (0, _params.stringify)(queryParams);
};

var getQueryParams = function getQueryParams() {
  return parseQueryParams(window.location.search);
};

exports.getQueryParams = getQueryParams;

var setQueryParams = function setQueryParams(updatedParams) {
  var newQueryString = stringifyQueryParams((0, _extends2.default)({}, getQueryParams(), updatedParams));
  var newUrl = window.location.pathname + "?" + newQueryString;
  history.replaceState(history.state, '', newUrl);
};

var useQueryParamsEffect = function useQueryParamsEffect(params) {
  var throttledSetQueryParams = (0, _customHooks.useThrottledFunc)(setQueryParams, 300);
  (0, _react.useEffect)(function () {
    throttledSetQueryParams(params);
  }, [params]);
};

exports.useQueryParamsEffect = useQueryParamsEffect;


//////////////////
// WEBPACK FOOTER
// ./js/utils/queryParamUtils.js
// module id = 108
// module chunks = 5 6 7